export default "__VITE_ASSET__LaNMjZOt__"